import { Component, Input, OnInit } from '@angular/core';
import { CmsService } from 'src/_service/CmsService';

@Component({
    selector: 'app-cms-text-block',
    templateUrl: './cms-text-block.component.html',
    imports: []
})
export class CmsTextBlockComponent implements OnInit {

  @Input() block: any;
  renderedText: any;

  constructor(
    private _cmsService: CmsService
  ) {
  }

  ngOnInit() {
    if (this.block?.text) {
      this.renderedText = this._cmsService.render_rt(this.block.text);
    } else if (this.block?.body) {
      this.renderedText = this._cmsService.render_rt(this.block.body);
    }
  }

}
